import React from "react";
// import { Backdrop, Modal, Fade } from "@material-ui/core";
import { Offline } from "react-detect-offline";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   modal: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   paper: {
//     backgroundColor: theme.palette.background.paper,
//     border: "2px solid #000",
//     boxShadow: theme.shadows[5],
//     width: "400px",
//   },
// }));

function OfflineComponent() {
  // const classes = useStyles();

  const polling = {
    url: `${process.env.REACT_APP_API_URL}/ping`,
  };

  return (
    <Offline polling={polling}>
      {/* <Modal
        className={classes.modal}
        open={true}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={true}>
          <div className={classes.paper}> */}
      <div
        style={{
          margin: "0 auto",
          width: "100%",
          backgroundColor: "#ff0000",
          color: "#fff",
          textAlign: "center",
          padding: "10px",
          position: "sticky",
          top: "0",
          zIndex: "9992",
        }}
      >
        No Internet Connection
      </div>
      {/* </div>
        </Fade>
      </Modal> */}
    </Offline>
  );
}

export default OfflineComponent;
